import { useEffect, useRef, useState } from "react";

// Streams Alpaca trades/quotes for the user's own linked account. Returns {} when not linked/Elite.
export default function useAlpacaTicks(symbol) {
  const [state, setState] = useState({ feed: null, price: null, bid: null, ask: null });
  const closed = useRef(false);

  useEffect(() => {
    if (!symbol || symbol.includes("-")) return undefined;
    closed.current = false;
    setState({ feed: null, price: null, bid: null, ask: null });
    const es = new EventSource(`/api/alpaca/stream?symbols=${encodeURIComponent(symbol)}`, { withCredentials: true });
    es.addEventListener("hello", (e) => {
      try { setState((s) => ({ ...s, feed: JSON.parse(e.data).feed })); } catch { /* ignore */ }
    });
    es.addEventListener("problem", () => { closed.current = true; es.close(); setState((s) => ({ ...s, feed: null })); });
    es.onmessage = (m) => {
      try {
        const t = JSON.parse(m.data);
        if (t.kind === "trade") setState((s) => ({ ...s, price: t.price }));
        else if (t.kind === "quote") setState((s) => ({ ...s, bid: t.bid, ask: t.ask }));
      } catch { /* ignore */ }
    };
    return () => { closed.current = true; es.close(); };
  }, [symbol]);

  return state;
}
